let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lGjdm")).then(() => parcelRequire('2aBLw'));